class CartTool extends HTMLElement {
constructor() {
super();
const buttons = this.querySelectorAll('.cartTool-item');
buttons.forEach((button) => {
button.addEventListener('click',(event) => {
const id = event.target.dataset.popup;
document.getElementById(id).classList.add('show');
document.querySelector('.previewCart').classList.add('active-tool');
})
})
}
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
constructor() {
super();
    
this.querySelector('button').addEventListener('click',(event) => {
document.querySelector('.popup-toolDown.show').classList.remove('show');
document.querySelector('.previewCart').classList.remove('active-tool');
})
}
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
constructor() {
super();
    
this.querySelector('[data-update-note]').addEventListener('click', (event) => {
this.val = this.querySelector('.text-area').value;
const body = JSON.stringify({ note: this.val });
fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }}).then(() => {
// Refresh the cart to reflect changes
Shopify.getCart((cart) => {
window.sharedFunctions?.updateSidebarCart(cart);
// Update visibility of note-saved div
const noteSavedDiv = document.querySelector('.note-saved');
if (noteSavedDiv) {
if (cart.note) {
noteSavedDiv.style.display = 'block'; // or 'flex', 'grid', etc., depending on layout needs
} else {
noteSavedDiv.style.display = 'none';
}
}
});
});
document.querySelector('.popup-toolDown.show').classList.remove('show');
document.querySelector('.previewCart').classList.remove('active-tool');
});
}
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
constructor() {
super();
if (localStorage.getItem('storedDiscount')){
this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
}
    
// Event listener for applying discount
this.querySelector('[data-update-coupon]').addEventListener('click', async (event) => {
this.val = this.querySelector('input[name="discount"]').value;
localStorage.setItem('storedDiscount', this.val);
      
try {
const response = await fetch(`/discount/${encodeURIComponent(this.val)}`);
const responseText = await response.text();
        
// Check if the coupon was valid based on the response
if (response.status !== 200) {
// Show error message if coupon is invalid
document.getElementById('invalidCouponMessage').style.display = 'block';
throw new Error('Invalid coupon code');
} else {
// Hide error message if coupon is valid
document.getElementById('invalidCouponMessage').style.display = 'none';
}

document.querySelector('.popup-toolDown.show')?.classList.remove('show');
document.querySelector('.previewCart')?.classList.remove('active-tool');
        
Shopify.getCart((cart) => {
window.sharedFunctions?.updateSidebarCart(cart);
});
} catch (error) {
console.error('Error applying discount:', error);
// The error message should already be shown if it was an invalid coupon
}
});

// Event listener for removing discount
this.querySelector('[data-remove-coupon]').addEventListener('click', async (event) => {
localStorage.removeItem('storedDiscount');
this.querySelector('input[name="discount"]').value = '';

try {
// Use cart update endpoint with empty discount to remove it (standard Shopify method)
const response = await fetch(`${routes.cart_update_url}?discount=`, {
method: 'POST',
headers: {
'Content-Type': 'application/x-www-form-urlencoded',
},
});
const responseText = await response.text();

document.getElementById('invalidCouponMessage').style.display = 'none'; // Ensure error message is hidden
document.querySelector('.popup-toolDown.show')?.classList.remove('show');
document.querySelector('.previewCart')?.classList.remove('active-tool');
        
Shopify.getCart((cart) => {
window.sharedFunctions?.updateSidebarCart(cart);
});
} catch (error) {
console.error('Error removing discount:', error);
}
});
}
}

customElements.define('coupon-code', CouponCode);